import { PartyRoom } from '@/types/PartyRoom'
import firebase from 'firebase'
import moment from 'moment'
import { User } from '@/types/User'
import SongRequest from '@/types/SongRequest'

export default class APIPartyRoom {
  static async addSongRequest (partyID: string, songRequest: SongRequest) {
    await firebase.firestore().collection('partyrooms').doc(partyID).collection('queue').add(songRequest)
  }

  static async removeSongRequest (partyID: string, songRequest: SongRequest) {
    await firebase.firestore().collection('partyrooms').doc(partyID).collection('queue').doc(songRequest.requestId).delete()
  }

  static async addUserToRoom (partyID: string, user: User) {
    await firebase.firestore().collection('partyrooms').doc(partyID).collection('users').doc(user.userID).set(user)
  }

  static async createRoom (name: string, userID: string): Promise<PartyRoom> {
    const id = APIPartyRoom.generateRoomCode(6)
    const room: PartyRoom = {
      partyID: id,
      created: moment().valueOf(),
      fallback: '',
      host: userID,
      name: name,
      votesForNext: 3,
      playingPlaylist: true
    }
    await firebase.firestore().collection('partyrooms').doc(id).set(room)
    return room
  }

  static async voteForNextSong (partyID: string, userID: string) {
    await firebase.firestore().collection('partyrooms').doc(String(partyID)).collection('votesForNext').add({ userID: userID })
  }

  private static generateRoomCode (length: number): string {
    let result = ''
    for (let i = 0; i < length; i++) {
      result += (Math.floor(Math.random() * 10))
    }
    return result
  }
}
